import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@adobe/cq-react-editable-components';

import { FWAContainer } from '../../../common/FWAContainer';
import { Row, Col } from '../../../common/Grid';
import './contactInfo.css';
import ContactInfoButton from './Components/contactInfoButton';
import MiniCart from '../../../common/MiniCart/redesign';
import {
  getAPPID,
  getSession,
  isPreorder,
  isMobile,
  isDesktopResolution,
  setSession,
  pdcAEMCheck,
  getUrlName,
  getFlowType,
  isSequentialFlow,
  cartContactInfoIntg,
  updateAccessbilityContent,
} from '../../../common/Helpers/index';
import { goToProcessStep } from '../../../../redirection';
import Notification from '../../../common/Notification/redesign/index';
import { store } from '../../../../configureStore';
import { checkCartidAndLQResponse, redirectToHomePage } from '../../../common/Helpers/commonLog';
import { getChannelId } from '../../../../services/HttpService';
import { callPerformanceMeasure } from '../../../common/Helpers/performanceMeasure';
import { eventDispatcher } from '../../../common/Tagging';
import IntegratedViewContext from '../../Cart/redesign/integratedViewContext';
import { performPreFetch, notificationProps } from '../Common/indexCommon';
// import CallCradleAPI from '../../../common/RequestAPI';
import logger from '../../../common/ErrorBoundary/logger_new';

export default class ContactInfo extends Container {
  constructor(props) {
    super(props);
    checkCartidAndLQResponse('contactInfo');
    this.isMobile = isMobile();
    this.handleLoad = this.handleLoad.bind(this);
  }

  componentDidMount() {
    const heading = this.childComponents.filter((item) => item.key.indexOf('/heading') >= 0);
    updateAccessbilityContent(heading[0]?.props?.heading);

    if (window.vzFlags?.iscontactButtonEnabled) {
      this.props.contactContinueCTA(false);
    }
    window.addEventListener('load', this.handleLoad);
    document.title = 'Verizon Wireless';
    if (cartContactInfoIntg() && this.context) {
      this.context.passbackContinueListener(this.onClickContinue.bind(this));
    }
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        performPreFetch();
      }
    };
    const isLoggedIn = getAPPID() === 'AAL';
    const isSeqFlow = isSequentialFlow();

    if (!isLoggedIn && !isSeqFlow) {
      this.props.callCradleApi();
      // TODO need remove the above BAU cradle api ACT145-2355
      // const pageName = getUrlName(window.location.pathname);
      // CallCradleAPI('FWA_ContactInfo', pageName, '');
    }
    if (this.props.setupType === 'Prof') {
      if (this.props?.eidQuestionsFromCreditStatus?.numOfQuestions > 0) {
        store.dispatch({ type: 'CLEAR_CREDIT_CHECK_RESPONSE' });
      }
    }

    if (isPreorder() && isLoggedIn) {
      let homePhoneAdded = false;

      const homePhoneResponse = this.props.cartDetails?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);
      if (homePhoneResponse && homePhoneResponse.length > 0) {
        homePhoneAdded = true;
      }
      this.props.buildShippingOptionsInputFromContactinfo(
        this.props.ShippingInfoDetails?.lines?.[0]?.shippingOptions?.[0],
        null,
        null,
        homePhoneAdded,
      );
      this.props.contactFetchSMSEnabledDevices(this.props?.cartDetails && this.props.cartDetails?.cartHeader?.fullAccountNumber);
    }
    this.props.editContactInfo('continue');
    this.props.showCart(false);
    this.props.billingAddressErroReload();
    if (!cartContactInfoIntg()) {
      this.props.invokeTaggingAPI();
    }
    if (this.props.contactInfoEditError && this.props.contactInfoEditError !== '') {
      this.props.updateContactInfoEditError('');
    }
    this.props.contactFnameCTA({ contactFormError: true });
    this.props.contactLnameCTA({ contactFormError: true });
    this.props.contactEmailCTA({ contactFormError: true });
    this.props.contactPhoneCTA({ contactFormError: true });
    this.props.securePinCTA({ pinError: true });
    this.props.secureConfirmPinCTA({ pinError: true });
    if (
      this.props.contactFormValues &&
      this.props.contactFormValues?.firstName !== '' &&
      this.props.contactFormValues?.lastName !== '' &&
      this.props.contactFormValues?.email !== '' &&
      this.props.contactFormValues.contactNumber?.length === 10
    ) {
      this.props.contactFnameCTA({ contactFormError: 'noError' });
      this.props.contactLnameCTA({ contactFormError: 'noError' });
      this.props.contactEmailCTA({ contactFormError: 'noError' });
      this.props.contactPhoneCTA({ contactFormError: 'noError' });
    }
    if (this.props.billingInfoEdited) {
      this.props.billingAddress1CTA({ billingFormError: true });
      this.props.billingAddress2CTA({ billingFormError: true });
      this.props.billingZipcodeCTA({ billingFormError: true });
      if (this.props.billingContactInfo && this.props.billingContactInfo?.address1 !== '' && this.props.billingContactInfo?.zipCode !== '') {
        this.props.billingAddress1CTA({ billingFormError: 'noError' });
        this.props.billingAddress2CTA({ billingFormError: 'noError' });
        this.props.billingZipcodeCTA({ billingFormError: 'noError' });
      }
    }

    const data = {
      pageName: 'contact',
    };
    if (isLoggedIn !== true && pdcAEMCheck()) {
      this.props.updatePdc(data);
    }
    store.dispatch({ type: 'CLEAR_PERSONAL_API_ERROR', value: true });
    store.dispatch({ type: 'CEF_CONTACT_INFO_ERROR', response: false, errorMessage: null });
    store.dispatch({ type: 'API_LOADED', response: true });
  }

  handleLoad = () => {
    const pageName = getUrlName(window.location.href);
    const markerValue = `${pageName}:ui:${getChannelId()}:${getFlowType()}:render`;

    if (window?.performance?.measure) {
      window.performance.measure(markerValue);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoad);
  }

  componentDidUpdate(prevProps) {
    // if (this.props.apiLoaded) {
    //   callPerformanceMeasure();
    // }
    if (document.readyState === 'complete') {
      callPerformanceMeasure();
    }
    if (!prevProps.contactInfoError && this.props.contactInfoError && this.context) {
      this.context.updateContactInfoUpdateFailed(true);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (isSequentialFlow()) {
      if ((this.props.setupType === 'Prof' || this.props.setupType === 'Self') && this.props.isConInfoEdited === false) {
        const creditApprovalStatus = nextProps.creditReviewSuccessResponse?.creditApprovalStatus;
        const eidQuestionnaire = nextProps.creditReviewSuccessResponse?.eidQuestionnaire;
        if (this.props.creditReviewSuccessResponse !== nextProps.creditReviewSuccessResponse) {
          if (creditApprovalStatus === 'AP' && eidQuestionnaire?.numOfQuestions === 0) {
            this.onClickContinue();
          } else if (creditApprovalStatus !== 'AP') {
            goToProcessStep(this.props.currentView.CreditStatus, this.props.history);
          }
        }
      } else if (this.props.isConInfoEdited === false) {
        this.onClickContinue();
      }
    }
  }

  onClickSeqFlowContinue = async () => {
    const personalInfo =
      this.props.cartSelector && this.props.cartSelector?.primaryUserInfo?.firstName
        ? this.props.cartSelector.primaryUserInfo
        : this.props.cartDetails?.mobilityUserData;
    const dob = this.props.cartSelector?.customerProfileForNSE?.dob ? this.props.cartSelector?.customerProfileForNSE?.dob : '';
    const ssn = this.props.cartSelector?.customerProfileForNSE?.ssn ? this.props.cartSelector?.customerProfileForNSE?.ssn : '';
    const ccRequest = {
      fName: personalInfo?.firstName ? personalInfo?.firstName : '',
      lName: personalInfo?.lastName ? personalInfo?.lastName : '',
      address: personalInfo?.address?.addressLine1 ? personalInfo?.address?.addressLine1 : '',
      line2: personalInfo?.address?.addressLine2 ? personalInfo?.address?.addressLine2 : '',
      zipCode: personalInfo?.address?.zipCode ? personalInfo?.address?.zipCode : '',
      city: personalInfo?.address?.city ? personalInfo?.address?.city : '',
      state: personalInfo?.address?.state ? personalInfo?.address?.state : '',
      phoneNumber: personalInfo?.contactPersonPhone ? personalInfo?.contactPersonPhone : '',
      dob,
      ssn,
    };
    const isSeqUPICompleted = getSession('isSeqUPICompleted');
    if (isSeqUPICompleted !== 'true' && this.props.isConInfoEdited === false) {
      // Initiate the updatePersonalInfo to update the mobility cutomer profile, updateISPUContactInfo, retrieve-cart and initiate credit-check call.
      await this.seqUpdatePersonalInfo(ccRequest);
    } else {
      this.onClickContinue();
    }
  };

  seqUpdatePersonalInfo = (creditCheckRequest) => {
    let inputdata = {};
    let param = {};
    let cartDetails = {};
    let homePhoneAdded = false;
    const mobilityUserData = this.props.cartDetails?.mobilityUserData ? this.props.cartDetails?.mobilityUserData : {};
    const homePhoneResponse = this.props.cartSelector?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);

    if (homePhoneResponse?.length > 0) {
      homePhoneAdded = true;
    }
    param = [
      {
        firstName: mobilityUserData?.firstName,
        lastName: mobilityUserData?.lastName,
        email: mobilityUserData?.emailId,
        contactNumber: mobilityUserData?.contactPersonPhone,
        receiveSpecialOfferUpdates: true,
        address: {
          addressLine1: mobilityUserData?.address?.addressLine1,
          addressLine2: mobilityUserData?.address?.addressLine2,
          apartmentNo: '',
          city: mobilityUserData?.address?.city,
          state: mobilityUserData?.address?.state,
          zipCode: mobilityUserData?.address?.zipCode,
        },
      },
    ];
    if (homePhoneAdded) {
      param.push({
        firstName: mobilityUserData?.firstName,
        lastName: mobilityUserData?.lastName,
        email: mobilityUserData?.emailId,
        contactNumber: mobilityUserData?.contactPersonPhone,
        receiveSpecialOfferUpdates: true,
        address: {
          addressLine1: mobilityUserData?.address?.addressLine1,
          addressLine2: mobilityUserData?.address?.addressLine2,
          apartmentNo: '',
          city: mobilityUserData?.address?.city,
          state: mobilityUserData?.address?.state,
          zipCode: mobilityUserData?.address?.zipCode,
        },
      });
    }
    if (this.props.cartSelector) {
      // TODO : need to verify
      cartDetails = {
        cartCreator:
          this.props.cartSelector.cartHeader && this.props.cartSelector.cartHeader.cartCreator ? this.props.cartSelector.cartHeader.cartCreator : '',
        accountNumber:
          this.props.cartSelector.cartHeader && this.props.cartSelector.cartHeader.fullAccountNumber
            ? this.props.cartSelector.cartHeader.fullAccountNumber
            : '',
        accountPin: this.props.cartSelector?.cartHeader?.accountPin ? this.props.cartSelector?.cartHeader?.accountPin : '',
      };
    }
    inputdata = {
      param,
      cartDetails,
    };
    // if (this.props.setupType === 'Prof' || this.props.setupType === 'Self') {
    this.props.postData(inputdata, homePhoneAdded, creditCheckRequest);
    // } else {
    //   // debugger;
    //   console.log('AAL', this.props.setupType);
    //   this.props.postData(inputdata, homePhoneAdded, null);
    // }
  };

  onClickContinue = () => {
    // debugger;
    const { currentView, isCreditStatusAvailable, orderDetails, history, creditStatusLanded } = this.props;
    const isNoSlotsAvailable = getSession('isNoSlotsAvailable');
    this.props.updateInfoSuccessFlag();
    // added condtion to toggle success flag again to default state
    // this.props.updateISPUContactInfoFlag();
    let updateView;
    if (isSequentialFlow()) {
      const { setupType, creditReviewSuccessResponse, cartSelector, getPaymentOptions } = this.props;
      const creditApprovalStatus = creditReviewSuccessResponse?.creditApprovalStatus;
      const { dueTodayAmount } = orderDetails || {};
      const { payments } = cartSelector || {};

      if (setupType === 'Prof') {
        if (isCreditStatusAvailable || (creditApprovalStatus && creditApprovalStatus !== 'AP')) {
          updateView = currentView.CreditStatus;
        } else if (dueTodayAmount === '0.0') {
          updateView = currentView.PRO.OrderReview;
        } else if (dueTodayAmount > 0) {
          if (!payments || payments.length === 0) {
            store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: true });
            getPaymentOptions();
          } else if (payments[0]?.paymentType) {
            updateView = currentView.PRO.OrderReview;
          }
        } else {
          updateView = currentView.PRO.Tos;
        }
      } else {
        updateView = currentView.SELF;
      }
    } else if (this.props.isLoggedIn !== true && this.props.setupType === 'Prof') {
      updateView = currentView.CreditCheck;
    } else if (this.props.setupType === 'Prof') {
      if (isCreditStatusAvailable) {
        updateView = currentView.CreditStatus;
      } else if (orderDetails.dueTodayAmount === '0.0') {
        // adding this condition to show new LF redesign page
        updateView = currentView.PRO.OrderReview;
      } else if (orderDetails.dueTodayAmount > 0) {
        if (this.props.isLoggedIn !== true) {
          updateView = currentView.CreditCheck;
        } else if (this.props.cartSelector && this.props.cartSelector.payments && this.props.cartSelector.payments.length === 0) {
          store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: true });
          this.props.getPaymentOptions();
        } else if (
          this.props.cartSelector &&
          this.props.cartSelector.payments &&
          this.props.cartSelector.payments.length > 0 &&
          this.props.cartSelector.payments[0] &&
          this.props.cartSelector.payments[0].paymentType
        ) {
          updateView = currentView.PRO.OrderReview;
        }
      } else {
        updateView = currentView.PRO.Tos;
      }
    } else if (isPreorder()) {
      if (getAPPID() === 'NSE') {
        updateView = currentView.CreditCheck;
      } else if (getAPPID() !== 'NSE' && isCreditStatusAvailable) {
        updateView = currentView.CreditStatus;
      } else if (isCreditStatusAvailable && !creditStatusLanded) {
        updateView = currentView.CreditStatus;
      } else if (orderDetails.dueTodayAmount === '0.0' && isNoSlotsAvailable !== 'Y') {
        updateView = currentView.OrderReview;
      } else if (isNoSlotsAvailable === 'Y') {
        if (
          this.props.cartSelector &&
          this.props.cartSelector.shippingDetails &&
          this.props.cartSelector.shippingDetails[0] &&
          this.props.cartSelector.shippingDetails[0].shippingCost > 0
        ) {
          if (this.props.cartSelector && this.props.cartSelector.payments && this.props.cartSelector.payments.length === 0) {
            updateView = currentView.Payment;
          } else if (
            this.props.cartSelector &&
            this.props.cartSelector.payments &&
            this.props.cartSelector.payments.length > 0 &&
            this.props.cartSelector.payments[0] &&
            this.props.cartSelector.payments[0].paymentType
          ) {
            updateView = currentView.OrderReview;
          }
        } else {
          updateView = currentView.OrderReview;
        }
      } else if (orderDetails.dueTodayAmount > 0) {
        if (this.props.isLoggedIn !== true) {
          updateView = currentView.CreditCheck;
        }
        if (this.props.cartSelector && this.props.cartSelector.payments && this.props.cartSelector.payments.length === 0) {
          store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: true });
          this.props.getPaymentOptions();
        } else if (
          this.props.cartSelector &&
          this.props.cartSelector.payments &&
          this.props.cartSelector.payments.length > 0 &&
          this.props.cartSelector.payments[0] &&
          this.props.cartSelector.payments[0].paymentType
        ) {
          updateView = currentView.OrderReview;
        }
      } else {
        updateView = currentView.OrderReview;
      }
      // debugger;
      goToProcessStep(updateView, this.props.history);
    } else {
      updateView = currentView.SELF;
      logger({
        json: true,
        eventType: 'FeInfo',
        message: `cart Contact Int route ${cartContactInfoIntg()} ${JSON.stringify(updateView)}}`,
        note: 'call cart Contact Int route',
        messageType: 'INFO',
      });
    }
    goToProcessStep(updateView, history);
  };

  cradleSuccess = () => {
    if (this.props.isCradleSuccess) {
      if (!this.continueNSEflow()) {
        this.props.toggleTermsandConditionsBanner(true);
        const { cradleThrottleList } = store.getState().contactInfo;
        // window.vzdl.event.value = 'event11';
        eventDispatcher('sendData', {
          name: '',
          data: {
            page: {
              contentFragments: 'Please accept the Terms and conditions',
            },
          },
          svars: {
            evar13: 'Please accept the Terms and conditions',
            evar22: 'TCs not accepted',
            evar64: 'shell account fwa',
            evar220: cradleThrottleList,
            evar221: 'shell acc fwa',
          },
        });

        return;
      }
      this.props.toggleTermsandConditionsBanner(false);
      //     if (!this.validateEmailAndPassword()) return;
    }
  };

  onClickNSEContinue = (notifyMessage) => {
    this.cradleSuccess();
    this.homePhoneAdd(notifyMessage);
  };

  homePhoneAdd = (notifyMessage) => {
    this.props.billingAddressErroReload();
    const { billingInfoNSE } = this.props;
    const addressLine1 = billingInfoNSE && billingInfoNSE.addressLine1;
    const addressLine2 = billingInfoNSE && billingInfoNSE.addressLine2;
    const city = billingInfoNSE && billingInfoNSE.city;
    const state = billingInfoNSE && billingInfoNSE.state;
    const zipCode = billingInfoNSE && billingInfoNSE.zipCode;
    let data = {};
    const listOfUnits = this.props?.unitlist?.map((obj) => obj.sublocation);
    let Adress2locusApi = '';
    if ((window.vzFlags?.isOnlyTypeAhead === 'app' && this.props.appConfigValue === true) || window.vzFlags?.isOnlyTypeAhead === 'yes') {
      if (listOfUnits?.includes(this.props?.billingFormValues?.address2)) {
        Adress2locusApi = this.props?.billingFormValues?.address2;
      } else {
        Adress2locusApi = '';
      }
    } else {
      Adress2locusApi = this.props?.billingFormValues?.address2;
    }
    if (this.props.billingInfoEdited) {
      data = {
        accountPin: this.props.securePinFormValues.accountPin,
        receiveSpecialOfferUpdates: this.props?.enableCheckbox,
        billingAddress: {
          // contactFormValues
          firstName: this.props.contactFormValues && this.props.contactFormValues.firstName ? this.props.contactFormValues.firstName : null,
          lastName: this.props.contactFormValues && this.props.contactFormValues.lastName ? this.props.contactFormValues.lastName : null,
          email: this.props.contactFormValues && this.props.contactFormValues.email ? this.props.contactFormValues.email : null,
          phoneNumber:
            this.props.contactFormValues && this.props.contactFormValues.contactNumber ? this.props.contactFormValues.contactNumber.trim() : null,
          addressLine1: this.props.billingFormValues && this.props.billingFormValues.address1 ? this.props.billingFormValues.address1 : null,
          addressLine2: Adress2locusApi || null,
          zipCode: this.props.billingFormValues && this.props.billingFormValues.zipCode ? this.props.billingFormValues.zipCode : null,
          city: this.props.billingFormValues && this.props.billingFormValues.city ? this.props.billingFormValues.city : null,
          state: this.props.billingFormValues && this.props.billingFormValues.state ? this.props.billingFormValues.state : null,
        },
      };
    } else {
      data = {
        accountPin: this.props.securePinFormValues.accountPin,
        receiveSpecialOfferUpdates: this.props?.enableCheckbox,
        billingAddress: {
          // contactFormValues
          firstName: this.props.contactFormValues && this.props.contactFormValues.firstName ? this.props.contactFormValues.firstName : null,
          lastName: this.props.contactFormValues && this.props.contactFormValues.lastName ? this.props.contactFormValues.lastName : null,
          email: this.props.contactFormValues && this.props.contactFormValues.email ? this.props.contactFormValues.email : null,
          phoneNumber: this.props.contactFormValues.contactNumber ? this.props.contactFormValues.contactNumber.trim() : null,
          addressLine1: addressLine1 || null,
          addressLine2: addressLine2 || null,
          zipCode: zipCode || null,
          city: city || null,
          state: state || null,
        },
      };
    }
    if (notifyMessage) {
      data.notifyMessage = notifyMessage;
    }
    let homePhoneAdded = false;
    const homePhoneResponse = this.props.cartSelector?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);
    if (homePhoneResponse && homePhoneResponse.length > 0) {
      homePhoneAdded = true;
    }
    const { isUniversalProfileCreated, password, isEmailExists, universalProfileCreationBannerMessages, previousEmail, isCradleSuccess } = this.props;
    this.props.getContactInfoOnClick(
      {
        ...data,
        password,
        isEmailExists,
        universalProfileCreationBannerMessages,
        previousEmail,
        currentEmail: this.props.contactFormValues?.email,
        isCradleSuccess,
        isUniversalProfileCreated,
        isSelfSetup: this.props.setupType === 'Self',
      },
      homePhoneAdded,
    );
  };

  focusTextBox = (elememnt) => {
    const elem = document.getElementById(elememnt);
    if (elem) {
      elem.scrollIntoView({ block: 'center' });
      elem.setAttribute('tabindex', '-10');
      elem.focus();
      // elem.autofocus();
    }
  };

  onClickNSEEnableContinue = (notifyMessage, continueCtaEnable) => {
    if (this.props.isCradleSuccess && window.vzFlags?.iscontactButtonEnabled) {
      setSession('ContinueButtonClick', true);
      this.props.contactContinueCTA(true);
      if (this.props.contactFnameCtaValue !== 'noError') {
        this.focusTextBox('contactInfoVdsFirstName');
      } else if (this.props.contactLnameCtaValue !== 'noError') {
        this.focusTextBox('contactInfoVdsLastName');
      } else if (this.props.contactEmailCtaValue !== 'noError') {
        this.focusTextBox('contactInfoVdsEmail');
      } else if (this.props.contactPhoneCtaValue !== 'noError') {
        this.focusTextBox('phoneNumber');
      } else if (this.props.billingInfoEdited && this.props.billingAddress1CtaValue !== 'noError') {
        this.focusTextBox('address1');
      } else if (window.vzFlags?.isOnlyTypeAhead === 'no' && this.props.billingInfoEdited && this.props.billingAddress2CtaValue !== 'noError') {
        this.focusTextBox('address2');
      } else if (this.props.billingInfoEdited && this.props.billingZipcodeCtaValue && this.props.billingZipcodeCtaValue !== 'noError') {
        this.focusTextBox('zipCode');
      } else if (this.props.password?.length === 0) {
        this.focusTextBox('shell-code');
      } else if (this.props.securePinCtaValue !== 'noError') {
        this.focusTextBox('accountPin');
      } else if (this.props.secureConfirmPinCtaValue !== 'noError') {
        this.focusTextBox('accountPinConfirm');
      }
    } else if (window.vzFlags?.iscontactButtonEnabled) {
      setSession('ContinueButtonClick', true);
      this.props.contactContinueCTA(true);
      if (this.props.contactFnameCtaValue !== 'noError') {
        this.focusTextBox('contactInfoVdsFirstName');
      } else if (this.props.contactLnameCtaValue !== 'noError') {
        this.focusTextBox('contactInfoVdsLastName');
      } else if (this.props.contactEmailCtaValue !== 'noError') {
        this.focusTextBox('contactInfoVdsEmail');
      } else if (this.props.contactPhoneCtaValue !== 'noError') {
        this.focusTextBox('phoneNumber');
      } else if (this.props.billingInfoEdited && this.props.billingAddress1CtaValue !== 'noError') {
        this.focusTextBox('address1');
      } else if (window.vzFlags?.isOnlyTypeAhead === 'no' && this.props.billingInfoEdited && this.props.billingAddress2CtaValue !== 'noError') {
        this.focusTextBox('address2');
      } else if (this.props.billingInfoEdited && this.props.billingZipcodeCtaValue && this.props.billingZipcodeCtaValue !== 'noError') {
        this.focusTextBox('zipCode');
      } else if (this.props.securePinCtaValue !== 'noError') {
        this.focusTextBox('accountPin');
      } else if (this.props.secureConfirmPinCtaValue !== 'noError') {
        this.focusTextBox('accountPinConfirm');
      }
    }
    this.cradleSuccess();
    if (this.enableNSECTA(continueCtaEnable) && window.vzFlags?.iscontactButtonEnabled) {
      this.homePhoneAdd(notifyMessage);
    }
  };

  contactInfoCheck = () => {
    if (
      this.props.contactFnameCtaValue &&
      this.props.contactFnameCtaValue === 'noError' &&
      this.props.contactFormValues?.firstName?.trim() !== '' &&
      this.props.contactLnameCtaValue &&
      this.props.contactLnameCtaValue === 'noError' &&
      this.props.contactFormValues?.lastName?.trim() !== '' &&
      this.props.contactEmailCtaValue &&
      this.props.contactEmailCtaValue === 'noError' &&
      this.props.contactFormValues?.email?.trim() !== '' &&
      this.props.contactPhoneCtaValue &&
      this.props.contactPhoneCtaValue === 'noError' &&
      this.props.contactFormValues?.contactNumber?.trim() !== ''
    ) {
      return true;
    }
    return false;
  };

  emailInfoCheck = () => {
    if (
      (this.props.isEmailSuccess &&
        (this.props?.isEmailSuccess?.valid === 'true' ||
          this.props?.isEmailSuccess?.valid === 'Valid' ||
          this.props?.isEmailSuccess?.valid === 'White_listed')) ||
      (this.props.contactEmailCtaValue &&
        this.props.contactEmailCtaValue === 'noError' &&
        this.props?.isEmailSuccess?.valid !== 'Manual_validation' &&
        this.props?.isEmailSuccess?.valid !== 'Fake' &&
        this.props?.isEmailSuccess?.valid !== 'Invalid' &&
        this.props?.isEmailSuccess?.valid !== 'false')
    ) {
      return true;
    }
    return false;
  };

  isEmailValidationSuccess = () => {
    const { latestSuccessfullyVerifiedEmail } = this.props;
    const currentEmail = this.props.contactFormValues?.email;

    return (
      latestSuccessfullyVerifiedEmail === currentEmail ||
      (this.props.isEmailSuccess &&
        (this.props.isEmailSuccess.valid === 'true' ||
          this.props.isEmailSuccess.valid === 'Valid' ||
          this.props.isEmailSuccess.valid === 'White_listed'))
    );
  };

  enableNSECTA = (continueCtaEnable) => {
    const isEmailValidated = this.isEmailValidationSuccess();
    if (!this.props.isCradleSuccess) return continueCtaEnable && isEmailValidated;

    if (continueCtaEnable) {
      if (this.props.isUniversalProfileCreated) {
        return isEmailValidated;
      }

      if (this.props.isEmailExists) {
        return true;
      }

      return this.props.password?.length && !this.props.passwordValidationFailed && isEmailValidated;
    }
    return false;
  };

  continueNSEflow = () => this.props.isPasswordRulesCheckboxChecked || this.props.isEmailExists;

  // validateEmailAndPassword = () => {
  //   if (this.props.contactFormValues?.email === this.props.password) {
  //     this.setState({
  //       emailAndPasswordEqualsErrorBannerProps: {
  //         type: 'error',
  //         renderIf: true,
  //         title: 'Your password cannot match your User ID. Please enter a new password.',
  //       },
  //       isEmailAndPasswordEqual: true,
  //     });
  //     return false;
  //   }
  //   this.setState({
  //     isEmailAndPasswordEqual: false,
  //     emailAndPasswordEqualsErrorBannerProps: {},
  //   });
  //   return true;
  // };
  static contextType = IntegratedViewContext;

  render() {
    // const type = viewport();
    // const flowType = getFlowType();
    // console.log("SELF", this.props.setupType);
    const { notifyMessage, contactBtnText } = this.props;
    const isLoggedIn = getAPPID() === 'AAL';
    const isSeqFlow = isSequentialFlow();
    if (isLoggedIn !== true && this.props.isUpdateInfoSuccess) {
      // debugger;
      this.props.contactFnameCTA({ contactFormError: true });
      this.props.contactLnameCTA({ contactFormError: true });
      this.props.contactEmailCTA({ contactFormError: true });
      this.props.contactPhoneCTA({ contactFormError: true });
      this.props.billingAddress1CTA({ billingFormError: true });
      this.props.billingZipcodeCTA({ billingFormError: true });
      this.props.securePinCTA({ pinError: true });
      this.props.secureConfirmPinCTA({ pinError: true });
      this.onClickContinue();
    }
    let components = this.childComponents;
    let showContinueBTN = true;
    if (this.props.editcontactInfo && this.props.editcontactInfo === 'edit') {
      showContinueBTN = false;
      components = components.filter((item) => item.key.indexOf('/billingInfo') <= 0);
    }
    const headerSection = components.filter((item) => item.key.indexOf('/heading') >= 0 || item.key.indexOf('/subHeading') >= 0);
    const contactInfoComponentsNSE = components.filter(
      (item) =>
        !(
          item.key.indexOf('/miniCartDueToday') >= 0 ||
          item.key.indexOf('/miniCartDueMonthly') >= 0 ||
          item.key.indexOf('/heading') >= 0 ||
          item.key.indexOf('/subHeading') >= 0
        ),
      // || (this.props.isCradleSuccess && item.key.indexOf('/secureAccountPin') >= 0)
    );
    const contactInfoComponentsAAL = components.filter(
      (item) =>
        !(
          item.key.indexOf('/miniCartDueToday') >= 0 ||
          item.key.indexOf('/miniCartDueMonthly') >= 0 ||
          item.key.indexOf('/secureAccountPin') >= 0 ||
          item.key.indexOf('/heading') >= 0 ||
          item.key.indexOf('/subHeading') >= 0
        ),
    );
    const miniCartComponents = components.filter(
      (item) => item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0,
    );
    // const errorMsg = null;
    let continueCtaEnable = false;
    if (this.props.contactFormInfoEnableBtn === true) {
      if (
        this.props.securePinCtaValue &&
        this.props.securePinCtaValue === 'noError' &&
        this.props.secureConfirmPinCtaValue &&
        this.props.secureConfirmPinCtaValue === 'noError'
      ) {
        continueCtaEnable = true;
      }
    }
    if (this.props.billingInfoEdited) {
      if (
        this.contactInfoCheck() &&
        this.props.billingAddress1CtaValue &&
        this.props.billingAddress1CtaValue === 'noError' &&
        this.props.billingContactInfo?.address1 !== undefined &&
        this.props.billingContactInfo?.address1?.trim() !== '' &&
        this.props.billingAddress2CtaValue &&
        this.props.billingAddress2CtaValue === 'noError' &&
        this.props.billingZipcodeCtaValue &&
        this.props.billingZipcodeCtaValue === 'noError' &&
        this.props.billingContactInfo?.zipCode?.trim() !== '' &&
        this.props.billingContactInfo?.city?.trim() !== '' &&
        this.props.billingContactInfo?.state?.trim() !== '' &&
        this.props.securePinCtaValue &&
        this.props.securePinCtaValue === 'noError' &&
        this.props.secureConfirmPinCtaValue &&
        this.props.secureConfirmPinCtaValue === 'noError' &&
        this.emailInfoCheck()
      ) {
        if (this.props?.billingContactInfo?.disabledContinue) {
          continueCtaEnable = true;
        } else {
          continueCtaEnable = false;
        }
      }
    } else if (!this.props.billingInfoEdited) {
      if (
        this.props.securePinCtaValue &&
        this.props.securePinCtaValue === 'noError' &&
        this.props.secureConfirmPinCtaValue &&
        this.props.secureConfirmPinCtaValue === 'noError' &&
        this.props.contactFnameCtaValue &&
        this.props.contactFnameCtaValue === 'noError' &&
        this.props.contactFormValues?.firstName?.trim() !== '' &&
        this.props.contactLnameCtaValue &&
        this.props.contactLnameCtaValue === 'noError' &&
        this.props.contactFormValues?.lastName?.trim() !== '' &&
        this.props.contactEmailCtaValue &&
        this.props.contactEmailCtaValue === 'noError' &&
        this.props.contactFormValues?.email?.trim() !== '' &&
        this.props.contactPhoneCtaValue &&
        this.props.contactPhoneCtaValue === 'noError' &&
        this.props.contactFormValues?.contactNumber?.trim() !== '' &&
        this.emailInfoCheck()
      ) {
        continueCtaEnable = true;
      }
    }
    if (
      this.props.shippingInfoState &&
      this.props.shippingInfoState.paymentSkipCall &&
      this.props.orderDetails.dueTodayAmount > 0 &&
      this.props.paymentInfoState
    ) {
      if (this.props.isBTAAvailable && this.props.isBTAAvailable.length > 0) {
        const isBTAAvail = this.props.isBTAAvailable[0];
        const data = {
          isBTA: isBTAAvail,
        };
        store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: true });
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        this.props.confirmSubmit(data);
      } else if (this.props.otherPaymentOptions && this.props.otherPaymentOptions.length > 0) {
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        const updateView = this.props.currentView.PRO.Payment;
        // debugger;
        goToProcessStep(updateView, this.props.history);
      }
    }
    const notificationValue = notificationProps(this.props);
    // const bannerDisplayed = billingAddressError || isInvalidZipcodeError || this.props.contactInfoEditError;

    const link = document.getElementById('transactionExpiryLink');
    if (link) {
      link.addEventListener('click', redirectToHomePage);
    }
    if (cartContactInfoIntg() && this.context?.updateNotificationProps && notificationProps.renderIf !== this.context?.notificationProps?.renderIf) {
      this.context.updateNotificationProps(notificationProps);
    }
    return (
      <>
        {!cartContactInfoIntg() ? (
          <div className="contactInfoContainer">
            <Notification {...notificationValue} />
            <Notification {...this.state.emailAndPasswordEqualsErrorBannerProps} />
            <FWAContainer enableLiveSupport topBufferAuto title={this.props.title}>
              <Row>
                <Col colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>{headerSection}</Col>
              </Row>
              {window.vzFlags?.iscontactButtonEnabled ? (
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 12, desktop: 8 }}>
                    {isLoggedIn || isSeqFlow ? <div>{contactInfoComponentsAAL}</div> : <div>{contactInfoComponentsNSE}</div>}
                    {!isDesktopResolution() &&
                      (isLoggedIn || isSeqFlow ? (
                        showContinueBTN && (
                          <div>
                            <ContactInfoButton
                              disabled={false}
                              onClickContinue={isSeqFlow ? this.onClickSeqFlowContinue : this.onClickContinue}
                              buttonName="Continue"
                              analyticstrack="5G-infoView"
                            />
                          </div>
                        )
                      ) : (
                        <div>
                          <ContactInfoButton
                            // disabled={!this.enableNSECTA(continueCtaEnable)}
                            onClickContinue={() => this.onClickNSEEnableContinue(notifyMessage, continueCtaEnable)}
                            buttonName="Continue"
                            analyticstrack="5G-infoView"
                            // contactBtnText={contactBtnText}
                          />
                        </div>
                      ))}
                  </Col>
                  <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}>
                    {isDesktopResolution() && (
                      <div>
                        <MiniCart
                          miniCartComponents={miniCartComponents}
                          showCartStatus={(iscartVisibleVal) => this.props.showCart(iscartVisibleVal)}
                          iscartVisible={this.props.cartDetails.isCartVisible}
                          topMarginStyle={60}
                        />
                        {isLoggedIn || isSeqFlow ? (
                          <div>
                            {showContinueBTN && (
                              <div>
                                <ContactInfoButton
                                  disabled={false}
                                  onClickContinue={isSeqFlow ? this.onClickSeqFlowContinue : this.onClickContinue}
                                  buttonName="Continue"
                                  analyticstrack="5G-infoView"
                                />
                              </div>
                            )}
                            {!showContinueBTN && <div id="buttonHolder" />}
                          </div>
                        ) : (
                          <div>
                            <ContactInfoButton
                              // disabled={!this.enableNSECTA(continueCtaEnable)}
                              onClickContinue={() => this.onClickNSEEnableContinue(notifyMessage, continueCtaEnable)}
                              buttonName="Continue"
                              analyticstrack="5G-infoView"
                              // contactBtnText={contactBtnText}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col colSizes={{ mobile: 4, tablet: 12, desktop: 8 }}>
                    {isLoggedIn || isSeqFlow ? <div>{contactInfoComponentsAAL}</div> : <div>{contactInfoComponentsNSE}</div>}
                    {!isDesktopResolution() &&
                      (isLoggedIn || isSeqFlow ? (
                        showContinueBTN && (
                          <div>
                            <ContactInfoButton
                              disabled={false}
                              onClickContinue={isSeqFlow ? this.onClickSeqFlowContinue : this.onClickContinue}
                              buttonName="Continue"
                              analyticstrack="5G-infoView"
                            />
                          </div>
                        )
                      ) : (
                        <div>
                          <ContactInfoButton
                            disabled={!this.enableNSECTA(continueCtaEnable)}
                            onClickContinue={() => this.onClickNSEContinue(notifyMessage)}
                            buttonName="Continue"
                            analyticstrack="5G-infoView"
                            contactBtnText={contactBtnText}
                          />
                        </div>
                      ))}
                  </Col>
                  <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}>
                    {isDesktopResolution() && (
                      <div>
                        <MiniCart
                          miniCartComponents={miniCartComponents}
                          showCartStatus={(iscartVisibleVal) => this.props.showCart(iscartVisibleVal)}
                          iscartVisible={this.props.cartDetails.isCartVisible}
                          topMarginStyle={60}
                        />
                        {isLoggedIn || isSeqFlow ? (
                          <div>
                            {showContinueBTN && (
                              <div>
                                <ContactInfoButton
                                  disabled={false}
                                  onClickContinue={isSeqFlow ? this.onClickSeqFlowContinue : this.onClickContinue}
                                  buttonName="Continue"
                                  analyticstrack="5G-infoView"
                                />
                              </div>
                            )}
                            {!showContinueBTN && <div id="buttonHolder" />}
                          </div>
                        ) : (
                          <div>
                            <ContactInfoButton
                              disabled={!this.enableNSECTA(continueCtaEnable)}
                              onClickContinue={() => this.onClickNSEContinue(notifyMessage)}
                              buttonName="Continue"
                              analyticstrack="5G-infoView"
                              contactBtnText={contactBtnText}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
              )}
            </FWAContainer>
          </div>
        ) : (
          <>{this.props.children}</>
        )}
      </>
    );
  }
}
ContactInfo.propTypes = {
  pageName: PropTypes.string,
  invokeTaggingAPI: PropTypes.func,
  injected: PropTypes.bool,
  selectiveRender: PropTypes.bool,
  disabled: PropTypes.oneOf('notifications', 'headers', 'mainView', 'miniCart', 'CTA', 'all'),
  contactContinueCTA: PropTypes.func,
};
